import TextProperties from '../abstract/text/text-properties';

export default class TitleProperties extends TextProperties {
  render() {
    return super.render('input');
  }
}
